
<div class="header bg-primary text-white">
	<h3 mat-dialog-title class="d-flex align-items-center">
		<span class="col pl-0">Update Post</span>
		<button mat-button type="button" (click)="closeDialog()"><i class="fas fa-times"></i></button>
	</h3>
</div>
<mat-dialog-content class="edit-posts">
	<app-create-post [updatePost]="data.item"></app-create-post>
</mat-dialog-content>